import * as Types from "../../../../types/__generated__/graphql";

import {gql} from "@apollo/client";
import * as Apollo from "@apollo/client";
const defaultOptions = {} as const;
export type CarePractitionerFragment = {
  __typename?: "CarePractitioner";
  id: string;
  firstName?: string | null;
  lastName?: string | null;
  credential?: string | null;
  languages?: Array<string> | null;
  coverImage?: {__typename?: "CarePractitionerImage"; id: string} | null;
};

export type CarePractitionersByDoctorIdsQueryVariables = Types.Exact<{
  doctorIds: Array<Types.Scalars["ID"]["input"]> | Types.Scalars["ID"]["input"];
}>;

export type CarePractitionersByDoctorIdsQuery = {
  __typename?: "Query";
  carePractitionersByDoctorIds?: Array<{
    __typename?: "CarePractitioner";
    id: string;
    firstName?: string | null;
    lastName?: string | null;
    credential?: string | null;
    languages?: Array<string> | null;
    coverImage?: {__typename?: "CarePractitionerImage"; id: string} | null;
  } | null> | null;
};

export const CarePractitionerFragmentDoc = gql`
  fragment CarePractitioner on CarePractitioner {
    id
    firstName
    lastName
    credential
    languages
    coverImage {
      id
    }
  }
`;
export const CarePractitionersByDoctorIdsDocument = gql`
  query CarePractitionersByDoctorIds($doctorIds: [ID!]!) {
    carePractitionersByDoctorIds(doctorIds: $doctorIds) {
      ...CarePractitioner
    }
  }
  ${CarePractitionerFragmentDoc}
`;

/**
 * __useCarePractitionersByDoctorIdsQuery__
 *
 * To run a query within a React component, call `useCarePractitionersByDoctorIdsQuery` and pass it any options that fit your needs.
 * When your component renders, `useCarePractitionersByDoctorIdsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useCarePractitionersByDoctorIdsQuery({
 *   variables: {
 *      doctorIds: // value for 'doctorIds'
 *   },
 * });
 */
export function useCarePractitionersByDoctorIdsQuery(
  baseOptions: Apollo.QueryHookOptions<
    CarePractitionersByDoctorIdsQuery,
    CarePractitionersByDoctorIdsQueryVariables
  >,
) {
  const options = {...defaultOptions, ...baseOptions};
  return Apollo.useQuery<
    CarePractitionersByDoctorIdsQuery,
    CarePractitionersByDoctorIdsQueryVariables
  >(CarePractitionersByDoctorIdsDocument, options);
}
export function useCarePractitionersByDoctorIdsLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    CarePractitionersByDoctorIdsQuery,
    CarePractitionersByDoctorIdsQueryVariables
  >,
) {
  const options = {...defaultOptions, ...baseOptions};
  return Apollo.useLazyQuery<
    CarePractitionersByDoctorIdsQuery,
    CarePractitionersByDoctorIdsQueryVariables
  >(CarePractitionersByDoctorIdsDocument, options);
}
export type CarePractitionersByDoctorIdsQueryHookResult = ReturnType<
  typeof useCarePractitionersByDoctorIdsQuery
>;
export type CarePractitionersByDoctorIdsLazyQueryHookResult = ReturnType<
  typeof useCarePractitionersByDoctorIdsLazyQuery
>;
export type CarePractitionersByDoctorIdsQueryResult = Apollo.QueryResult<
  CarePractitionersByDoctorIdsQuery,
  CarePractitionersByDoctorIdsQueryVariables
>;
